
import { computed, defineComponent, PropType, reactive, toRefs } from 'vue';
import { templateRef } from '@vueuse/core';
import { image } from 'assets/moc';

const MEDIA_TYPES = {
  PICTURE: 'image',
  VIDEO: 'video',
  VIDEO_INTERNAL: 'video_internal',
  VIDEO_EXTERNAL: 'video_external',
};

export interface Data {
  MEDIA_TYPES: Record<string, unknown>,
  optionsSlider: Record<string, unknown>,

}

export interface ItemsData{
  type: any;
  data: any;
}

export default defineComponent({
  name: 'BuilderImageVideo',
  props: {
    legend: {
      type: String,
      default: null,
    },
    /** List of medias (video/image) */
    items: {
      type: Array as PropType<BuilderGalleryItems[]>,
      default: null,
    }
  },
  
  setup(props){
    const elNext:Obj = templateRef('elNext')
    const elPrev:Obj = templateRef('elPrev')

    const options = { ...props }

    const isSwiper = computed(()=>{
      return options.items?.length >= 2;
    });
    
    const data: Data = reactive({
      MEDIA_TYPES,
      optionsSlider: {
        loop: true,
        centeredSlides: true,
        // mobile
        spaceBetween: 10,
        slidesPerView: 'auto',
        breakpoints: {
          // desktop
          1001: {
            spaceBetween: 20,
            // slidesPerView: 1,
          },
        }
      },
    })
    
    return {
      ...toRefs(data), //data
      elNext, 
      elPrev,
      props,
      isSwiper,
      image
    };
  },
});
